import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class PartnershipApi extends EntityApi {
    protected static GET_COLLECTION_MY_PARTNERSHIPS = "/api/partnerships/my";

    protected static POST_COLLECTION = "/api/partnerships";

    protected static GET_ITEM = "/api/partnerships/{id}";

    protected static PUT_ITEM = "/api/partnerships/{id}";

    protected static PATCH_PARTNERSHIP_CHANGE_STATUS =
        "/api/partnerships/{id}/change-status";

    protected static PATCH_PARTNERSHIP_CHANGE_REFERENCE_TRAINER =
        "/api/partnerships/{id}/change-reference_trainer";

    protected static DELETE_ITEM = "/api/partnerships/{id}";

    public static async getCollectionMyPartnershipsStatus<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_PARTNERSHIPS,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async patchPartnershipChangeStatus<R, P>(
        id: number | string,
        entity: P,
        extraParams: PrimitiveObject = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.PATCH_PARTNERSHIP_CHANGE_STATUS,
        };
        return this.patchItem(id, entity, extraParams);
    }

    public static async patchPartnershipChangeReferenceTrainer<R, P>(
        id: number | string,
        entity: P,
        extraParams: PrimitiveObject = {}
    ): Promise<FinalResponse<R | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.PATCH_PARTNERSHIP_CHANGE_REFERENCE_TRAINER,
        };
        return this.patchItem(id, entity, extraParams);
    }
}
